import Select from "react-select";

function DonorFormFields({
  userDetailsFormData,
  handleUserDetailsChange,
  agencies = [],
  agenciesLoading,
  modes = [],
  modesLoading,
  mentors = [],
  mentorsLoading,
  handleMentorSelect,
  role,
}) {
  // console.log("Rendering DonorFormFields with data:", userDetailsFormData);

  // console.log("Processing Agencies:", agencies);

  return (
    <>
      <div className="card border">
        <div className="card-body">
          <h5>
            <b>Donor Details</b>
          </h5>
          <div className="row mt-3">
            <div className="mb-3 col-md-6">
              <label htmlFor="donorId" className="form-label">
                Donor ID
              </label>
              <input
                type="text"
                className="form-control"
                id="donorId"
                value={userDetailsFormData.donorId}
                onChange={handleUserDetailsChange}
                placeholder="Enter donor ID (e.g. DNR1024)"
                required
                readOnly={true} // Donor ID should not be editable
                pattern="[A-Za-z0-9]+"
                title="Donor ID must be alphanumeric"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="fullName" className="form-label">
                Full Name
              </label>
              <input
                type="text"
                className="form-control"
                id="fullName"
                value={userDetailsFormData.fullName}
                onChange={handleUserDetailsChange}
                placeholder="Enter full name"
                required
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="initiatedName" className="form-label">
                Initiated Name
              </label>
              <input
                type="text"
                className="form-control"
                id="initiatedName"
                value={userDetailsFormData.initiatedName}
                onChange={handleUserDetailsChange}
                placeholder="Enter initiated name"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="mentorSelect" className="form-label">
                Mentor
              </label>
              <Select
                id="mentorSelect"
                inputId="mentorSelect"
                isDisabled={role === "mentor"}
                isClearable
                isSearchable
                isLoading={mentorsLoading}
                placeholder="Search & select mentor..."
                options={mentors.map((m) => ({
                  value: m.id,
                  label: `${m.mentor_name || m.full_name}${m.phone_number ? ` (${m.phone_number})` : ""}`,
                  mentorName: m.mentor_name || m.full_name,
                  mentorId: m.id,
                }))}
                value={
                  userDetailsFormData.mentorId
                    ? mentors
                        .map((m) => ({
                          value: m.id,
                          label: `${m.mentor_name || m.full_name}${m.phone_number ? ` (${m.phone_number})` : ""}`,
                          mentorName: m.mentor_name || m.full_name,
                          mentorId: m.id,
                        }))
                        .find(
                          (opt) =>
                            String(opt.value) ===
                            String(userDetailsFormData.mentorId),
                        ) ||
                      (userDetailsFormData.mentorsName
                        ? {
                            value: userDetailsFormData.mentorId,
                            label: userDetailsFormData.mentorsName,
                            mentorName: userDetailsFormData.mentorsName,
                            mentorId: userDetailsFormData.mentorId,
                          }
                        : null)
                    : userDetailsFormData.mentorsName
                      ? mentors
                          .map((m) => ({
                            value: m.id,
                            label: `${m.mentor_name || m.full_name}${m.phone_number ? ` (${m.phone_number})` : ""}`,
                            mentorName: m.mentor_name || m.full_name,
                            mentorId: m.id,
                          }))
                          .find(
                            (opt) =>
                              opt.mentorName?.toLowerCase() ===
                              userDetailsFormData.mentorsName?.toLowerCase(),
                          ) || {
                          value: "",
                          label: userDetailsFormData.mentorsName,
                          mentorName: userDetailsFormData.mentorsName,
                          mentorId: "",
                        }
                      : null
                }
                onChange={(selected) => {
                  if (handleMentorSelect) {
                    handleMentorSelect(selected);
                  } else {
                    handleUserDetailsChange({
                      target: {
                        id: "mentorsName",
                        value: selected
                          ? selected.mentorName || selected.label
                          : "",
                      },
                    });
                    handleUserDetailsChange({
                      target: {
                        id: "mentorId",
                        value: selected ? selected.value : "",
                      },
                    });
                  }
                }}
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="phoneNumber" className="form-label">
                Mobile Number
              </label>
              <input
                type="text"
                maxLength={10}
                className="form-control"
                id="phoneNumber"
                value={userDetailsFormData.phoneNumber}
                onChange={handleUserDetailsChange}
                placeholder="Enter 10-digit mobile number"
                required
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="email" className="form-label">
                Email ID
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={userDetailsFormData.email}
                onChange={handleUserDetailsChange}
                placeholder="Enter email address"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="gender" className="form-label">
                Gender
              </label>
              <select
                className="form-select"
                id="gender"
                name="gender"
                value={userDetailsFormData.gender}
                onChange={handleUserDetailsChange}
              >
                <option value="">Select Gender</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="processingAgency" className="form-label">
                Processing Agency
              </label>
              <select
                className="form-select"
                id="processingAgency"
                name="processingAgency"
                value={userDetailsFormData.processingAgency}
                onChange={handleUserDetailsChange}
              >
                <option value="">Select Processing Agency</option>
                {agenciesLoading ? (
                  <option value="" disabled>
                    Loading agencies...
                  </option>
                ) : (
                  agencies.map((agency) => (
                    <option key={agency.id || agency.name} value={agency.name}>
                      {agency.name}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="city" className="form-label">
                City
              </label>
              <input
                type="text"
                className="form-control"
                id="city"
                value={userDetailsFormData.city}
                onChange={handleUserDetailsChange}
                placeholder="Enter city"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="state" className="form-label">
                State
              </label>
              <input
                type="text"
                className="form-control"
                id="state"
                value={userDetailsFormData.state}
                onChange={handleUserDetailsChange}
                placeholder="Enter state"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="donor_category" className="form-label">
                Category
              </label>
              <select
                className="form-select"
                id="donor_category"
                value={
                  userDetailsFormData.donor_category ||
                  userDetailsFormData.category ||
                  "voice"
                }
                onChange={handleUserDetailsChange}
              >
                <option value="voice">voice</option>
                <option value="campus_preaching">campus preaching</option>
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="zipCode" className="form-label">
                Zip Code
              </label>
              <input
                type="text"
                className="form-control"
                id="zipCode"
                value={userDetailsFormData.zipCode}
                onChange={handleUserDetailsChange}
                placeholder="Enter zip or postal code"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="dateOfBirth" className="form-label">
                Date of Birth
              </label>
              <input
                type="date"
                className="form-control"
                id="dateOfBirth"
                value={userDetailsFormData.dateOfBirth}
                onChange={handleUserDetailsChange}
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="want80G" className="form-label">
                Want 80G Certificate?
              </label>
              <select
                className="form-select"
                id="want80G"
                name="want80G"
                value={userDetailsFormData.want80G}
                onChange={handleUserDetailsChange}
              >
                <option value="">Select Option</option>
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </div>

            {userDetailsFormData.want80G == "Y" && (
              <div className="mb-3 col-md-6">
                <label htmlFor="panNo" className="form-label">
                  PAN Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="panNo"
                  required
                  value={userDetailsFormData.panNo}
                  onChange={handleUserDetailsChange}
                  placeholder="Enter PAN number (required for 80G)"
                />
              </div>
            )}

            <div className="mb-3 col-md-6">
              <label htmlFor="deductionDay" className="form-label">
                Deduction Day
              </label>
              <select
                className="form-select"
                id="deductionDay"
                name="deductionDay"
                value={userDetailsFormData.deductionDay}
                onChange={handleUserDetailsChange}
              >
                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="address" className="form-label">
                Residential Address
              </label>
              <textarea
                className="form-control"
                id="address"
                rows="3"
                required
                value={userDetailsFormData.address}
                onChange={handleUserDetailsChange}
                placeholder="Enter residential address"
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="permanentAddress" className="form-label">
                Permanent Address
              </label>
              <textarea
                className="form-control"
                id="permanentAddress"
                rows="3"
                value={userDetailsFormData.permanentAddress}
                onChange={handleUserDetailsChange}
                placeholder="Enter permanent address"
              />
              <p className="text-danger font-weight-bold text-sm">
                As mentioned in the Aadhar Card
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card border">
        <div className="card-body">
          <h5>
            <b>Donation Details</b>
          </h5>
          <div className="row mt-3">
            <div className="mb-3 col-md-6">
              <label htmlFor="mode" className="form-label">
                Donation Mode
              </label>
              <select
                className="form-select"
                id="mode"
                name="mode"
                value={userDetailsFormData.mode}
                onChange={handleUserDetailsChange}
              >
                <option value="">Select Donation Mode</option>
                {modesLoading ? (
                  <option value="" disabled>
                    Loading modes...
                  </option>
                ) : (
                  modes.map((m) => (
                    <option key={m.id || m.name} value={m.name}>
                      {m.name}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="donation_type" className="form-label">
                Donor Type
              </label>
              <select
                className="form-select"
                id="donation_type"
                name="donation_type"
                value={userDetailsFormData.donation_type}
                onChange={handleUserDetailsChange}
              >
                <option value="">Select Donor Type</option>
                <option value="Regular">Regular</option>
                <option value="Occasional">Occasional</option>
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="startDate" className="form-label">
                First Donation Date
              </label>
              <input
                type="date"
                className="form-control"
                id="startDate"
                value={userDetailsFormData.startDate}
                onChange={handleUserDetailsChange}
                readOnly
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="stopHoldDate" className="form-label">
                Last Donation Date
              </label>
              <input
                type="date"
                className="form-control"
                id="stopHoldDate"
                value={userDetailsFormData.stopHoldDate}
                onChange={handleUserDetailsChange}
                readOnly
              />
            </div>

            <div className="mb-3 col-md-6">
              <label htmlFor="totalDonation" className="form-label">
                Total Donation Amount
              </label>
              <input
                type="text"
                className="form-control"
                id="totalDonation"
                value={userDetailsFormData.totalDonation}
                onChange={handleUserDetailsChange}
                // readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DonorFormFields;
